import { render, staticRenderFns } from "./182.vue?vue&type=template&id=f5d5d298&scoped=true&"
var script = {}
import style0 from "./182.vue?vue&type=style&index=0&id=f5d5d298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d5d298",
  null
  
)

export default component.exports